import {
  green,
  gray,
  lightYellow,
  purple,
  red,
} from '@synoptic/ui-kit/palette.ts';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { style, styleVariants } from '@vanilla-extract/css';
import { StreamState } from '@/__generated__/graphql.ts';

const baseStreamState = style({
  color: themeVars.badge.foreground.default,
});

export const streamStateTag = styleVariants({
  [StreamState.Draft]: [
    baseStreamState,
    {
      selectors: {
        '&:is(&)': {
          backgroundColor: purple[50],
        },
      },
    },
  ],
  [StreamState.Active]: [
    baseStreamState,
    {
      selectors: {
        '&:is(&)': {
          backgroundColor: green[100],
        },
      },
    },
  ],
  [StreamState.Inactive]: [
    baseStreamState,
    {
      selectors: {
        '&:is(&)': {
          backgroundColor: gray[100],
        },
      },
    },
  ],
  [StreamState.OnHold]: [
    baseStreamState,
    {
      selectors: {
        '&:is(&)': {
          backgroundColor: lightYellow[100],
        },
      },
    },
  ],
  [StreamState.Deleted]: [
    baseStreamState,
    {
      selectors: {
        '&:is(&)': {
          backgroundColor: red[100],
        },
      },
    },
  ],
});

export const publishedStreamTagIcon = style({
  color: themeVars.color.icon.secondary,
});
